import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';

import Amplify, { API, Auth } from 'aws-amplify';
const useStyles = makeStyles(theme => ({
  root: {
    
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();

  const [notifications] = useState([]);

  
  const signOut =() =>{
    Auth.signOut();
  }
  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="default"
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            src="../../../favicon.ico"
          />
        </RouterLink>
        <Typography variant="h7" color="inherit" align="left" noWrap>
          Aplicación de Citas
        </Typography>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          
          <IconButton
            className={classes.signOutButton}
            color="inherit"
            onClick={signOut}
          >
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
